<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<template>
  <ion-card
    outlined
    class="drag-area"
    :class="{
      'hide-border': iframeUrl !== '' && !iframeError,
    }"
  >
    <template v-if="iframeUrl !== '' && !iframeError">
      <iframe
        title="mediaSource"
        ref="iframeRef"
        width="100%"
        height="100%"
        :src="iframeUrl"
        allowfullscreen
      ></iframe>
    </template>
  </ion-card>
</template>

<script lang="ts" setup>
  import getVideoId from 'get-video-id';
  import { onMounted, ref, watch } from 'vue';
  import { IonCard } from '@ionic/vue';

  const emit = defineEmits(['error', 'success', 'remove-image']);

  const iframeError = ref(false);
  const props = defineProps({
    icon: {
      type: String,
      required: false,
      default: '',
    },
    url: {
      type: String,
      required: false,
      default: '',
    },
  });

  const isLoading = ref(false);
  const iframeUrl = ref('');

  const formatVideoUrl = (url: string) => {
    const urlDomain = getVideoId(url).service;
    const urlId = getVideoId(url).id;

    switch (urlDomain) {
      case 'youtube':
        iframeUrl.value = `https://www.youtube.com/embed/${urlId}`;
        break;
      case 'vimeo':
        iframeUrl.value = `https://player.vimeo.com/video/${urlId}`;
        break;
      case 'videopress':
        iframeUrl.value = `https://videopress.com/embed/${urlId}`;
        break;
      case 'microsoftstream':
        iframeUrl.value = `https://web.microsoftstream.com/embed/video/${urlId}?&`;
        break;
      case 'dailymotion':
        iframeUrl.value = `https://www.dailymotion.com/embed/video/${urlId}`;
        break;
      case 'loom':
        iframeUrl.value = `https://www.loom.com/embed/${urlId}`;
        break;
    }

    emit('success');
  };

  const validateUrl = async (url: string) => {
    if (getVideoId(url).id) {
      await formatVideoUrl(url);
    } else {
      iframeError.value = true;
      emit('error', 'unsuported');
    }
  };

  const confirmUrl = async () => {
    isLoading.value = true;
    iframeError.value = false;
    if (props.url !== '') {
      await validateUrl(props.url);
    } else {
      iframeUrl.value = '';
    }
    isLoading.value = false;
  };

  watch(props, () => {
    confirmUrl();
  });

  onMounted(() => {
    confirmUrl();
  });
</script>

<style lang="scss" scoped>
  iframe {
    background-color: black;
    margin-left: -1px;
    min-height: 500px;
  }
  .image-drop-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .hide-border {
    border: none !important;
  }
</style>
